function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

export default function () {
  return this.each(remove);
}